import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ActionsTemplateProps {
  row: any;
  user: any;
  onClickGenerateNewsletter: (newsletterId: number) => void;
  onClickDelete: (id: number) => void;
  onClickEdit: (id: number) => void;
  onClickSendNewsletter: (id: number) => void;
}

const ActionsTemplate = ({
  row,
  user,
  onClickGenerateNewsletter,
  onClickDelete,
  onClickEdit,
  onClickSendNewsletter
}: ActionsTemplateProps) => {
  const { t } = useTranslation();

  return (
    <div className='text-align-center'>
      {(user.roleId === 1 || user.roleId === 2) && !row.sentAt && (
        <Button
          title={t('BACK_OFFICE.NEWSLETTERS.GENERATE_NEWSLETTER')}
          className='background button-border-radius cursor-pointer'
          onClick={() => onClickGenerateNewsletter(row.id)}>
          {t('BACK_OFFICE.NEWSLETTERS.GENERATE_NEWSLETTER_INITIAL')}
        </Button>
      )}
      &nbsp;&nbsp;&nbsp;
      {(user.roleId === 1 || user.roleId === 2) && !row.sentAt && (
        <Button
          title={t('BACK_OFFICE.NEWSLETTERS.EDIT_NEWSLETTER')}
          className='background button-border-radius cursor-pointer min-w-10'
          onClick={() => onClickEdit(row.id)}>
          {t('BACK_OFFICE.NEWSLETTERS.EDIT_NEWSLETTER_INITIAL')}
        </Button>
      )}
      &nbsp;&nbsp;&nbsp;
      {user.roleId === 1 && !row.sentAt && (
        <Button
          title={t('BACK_OFFICE.NEWSLETTERS.DELETE_NEWSLETTER')}
          className='background button-border-radius cursor-pointer min-w-10'
          onClick={() => onClickDelete(row.id)}>
          {t('BACK_OFFICE.NEWSLETTERS.DELETE_NEWSLETTER_INITIAL')}
        </Button>
      )}
      &nbsp;&nbsp;&nbsp;
      {user.roleId === 1 && !row.sentAt && (
        <Button
          title={t('BACK_OFFICE.NEWSLETTERS.SEND_NEWSLETTER')}
          className='background button-border-radius cursor-pointer min-w-10'
          onClick={() => onClickSendNewsletter(row.id)}>
          {t('BACK_OFFICE.NEWSLETTERS.SEND_NEWSLETTER_INITIAL')}
        </Button>
      )}
    </div>
  );
};

export default ActionsTemplate;
